module.exports = __webpack_public_path__ + "static/media/cephalicPerimeter.b41658e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/cephalicPerimeter.svg
// module id = 1463
// module chunks = 0